(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;

  const DELIGHTCHAT_PATTERNS = [
    'script-tags.delightchatmedia.com/ssw/',
    'script-tags.delightchatmedia.com/abandoned-cart/'
  ];

  const deferredUrls = new Set();
  let isLoaded = false;
  let loadPromise = null;

  function isDelightChatScript(src) {
    if (!src) return false;

    for (const pattern of DELIGHTCHAT_PATTERNS) {
      if (src.indexOf(pattern) !== -1) return true;
    }

    return false;
  }

  function shouldBlockScript(node) {
    if (!node || node.tagName !== 'SCRIPT' || isLoaded) return false;

    const src = node.src || node.getAttribute('src');
    if (!isDelightChatScript(src)) return false;

    deferredUrls.add(src);
    return true;
  }

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (shouldBlockScript(newNode)) return newNode;
    return originalInsertBefore.call(this, newNode, referenceNode);
  };

  const originalAppendChild = Node.prototype.appendChild;
  Node.prototype.appendChild = function (child) {
    if (shouldBlockScript(child)) return child;
    return originalAppendChild.call(this, child);
  };

  function getFallbackUrls() {
    const shop = window.Shopify && window.Shopify.shop ? window.Shopify.shop : '';

    return [
      'https://script-tags.delightchatmedia.com/ssw/index.js?shop=' + shop,
      'https://script-tags.delightchatmedia.com/abandoned-cart/index.js?unique_id=cc2f2c52-39c7-4ecb-bf53-4f476ed015e3&shop=' + shop
    ];
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = function () {
        resolve();
      };
      script.onerror = function () {
        reject(new Error('Failed to load DelightChat script'));
      };
      // Use native appendChild — patched version would block our own DelightChat loads.
      originalAppendChild.call(document.head, script);
    });
  }

  function waitForWidget(maxMs) {
    const timeout = maxMs || 8000;

    return new Promise(function (resolve) {
      const start = Date.now();

      function check() {
        if (window.dcwidget || document.getElementById('delightchat-widget')) {
          resolve();
          return;
        }

        if (Date.now() - start >= timeout) {
          resolve();
          return;
        }

        setTimeout(check, 100);
      }

      check();
    });
  }

  function loadDelightChat() {
    if (isLoaded) return Promise.resolve();
    if (loadPromise) return loadPromise;

    loadPromise = (async function () {
      const urls = deferredUrls.size ? Array.from(deferredUrls) : getFallbackUrls();
      const ordered = urls.sort(function (a) {
        return a.indexOf('/ssw/') !== -1 ? -1 : 1;
      });

      for (const url of ordered) {
        await loadScript(url);
      }

      isLoaded = true;
      await waitForWidget();
    })().catch(function () {
      loadPromise = null;
    });

    return loadPromise;
  }

  window.MPB = window.MPB || {};
  window.MPB.loadDelightChat = loadDelightChat;

  function scheduleIdleLoad() {
    const run = function () {
      loadDelightChat();
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(run, { timeout: 5000 });
    } else {
      setTimeout(run, 4000);
    }
  }

  function onFirstInteraction() {
    loadDelightChat();
    document.removeEventListener('pointerdown', onFirstInteraction, true);
    document.removeEventListener('keydown', onFirstInteraction, true);
    window.removeEventListener('scroll', onFirstInteraction, true);
  }

  document.addEventListener('pointerdown', onFirstInteraction, { capture: true, passive: true });
  document.addEventListener('keydown', onFirstInteraction, { capture: true });
  window.addEventListener('scroll', onFirstInteraction, { capture: true, passive: true });
  window.addEventListener('load', scheduleIdleLoad);
})();